<template>
  <div>
    <div class="d-flex">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        outlined
        :placeholder="$t('search')"
        dense
        style="max-width: 250px;"
        v-model="search"
        @input="resetSearchOnEmpty"
      >
      <!-- <template slot="append-outer">
        
      <v-tooltip top color="black">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" dense>
            mdi-information-outline
          </v-icon>
        </template>
        <span>{{$t('animal.conceptionInfo.searchSireEmbryoSurrogate')}}.</span>
      </v-tooltip>
      </template> -->
      </v-text-field>
      <v-btn
        color="primary"
        height="40"
        width="40"
        max-width="40"
        outlined
        class="ml-2"
        @click="searchData"
        :disabled="search.length < 1"
      >
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        height="40"
        class="ml-2"
        @click="addNewRecordModal = true"
      >
        Add New Record
      </v-btn>
      <v-spacer></v-spacer>
      <div class="py-1 title">
        {{ from }} - {{ to }} {{$t('of')}} {{ totalConception }}
      </div>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="options.page <= 1"
        @click="pageChange(false)"
      >
        <v-icon dark> mdi-chevron-left </v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="options.page >= totalPages"
        @click="pageChange(true)"
      >
        <v-icon dark> mdi-chevron-right </v-icon>
      </v-btn>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        left
        :min-width="417"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark> mdi-cog-outline </v-icon>
          </v-btn>
        </template>

        <v-card width="417">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("customization")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <div class="pl-3 pt-2 font-weight-normal">
              {{ $t("recordsPerPage") }}
            </div>
            <v-list-item>
              <v-list-item-content>
                <v-slider
                  v-model="itemsPerPageSlider"
                  :tick-labels="itemsPerPageOptions"
                  :max="3"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-n3"></v-divider>
          </v-list>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col
                  class="mt-n9"
                  cols="6"
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-checkbox
                    v-model="selectedHeaders"
                    :label="header.text"
                    color="primary"
                    :value="header.text"
                    hide-details
                    :disabled="header.value=='action'"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-layout justify-center>
            <v-card-actions class="mb-5">
              <v-spacer></v-spacer>

              <v-btn
                outlined
                color="primary"
                @click="menu = false"
                width="190"
              >
                {{ $t("restoreDefault") }}
              </v-btn>
              <v-btn
                color="primary"
                width="190"
                @click="resetTableStructure"
              >
                {{ $t("apply") }}
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-menu>
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="conceptionData"
      :items-per-page="5"
      hide-default-footer
      :loading="loading"
      :loading-text="$t('loadingData')"
      :options.sync="options"
      :server-items-length="totalConception"
    >
      <template v-slot:item.action="{item}">
        <v-btn icon color="primary" @click="editItem(item)"><v-icon>mdi-pencil</v-icon></v-btn>
        <v-btn icon color="red"  @click="deleteConfirm(item)"><v-icon>mdi-trash-can</v-icon></v-btn>
      </template>
      <template v-slot:footer></template>
    </v-data-table>
    <ConfirmBox
        :title="confirmElements.title"
        :message="confirmElements.message"
        :cancelBtnText="confirmElements.cancelBtnText"
        :confirmBtnText="confirmElements.confirmBtnText"
        :confirmData="confirmElements.confirmData"
        :dialog="confirm"
        @confirm:action="confirmDelete"
      />
      <SemenEmbryoForm 
        v-if="addNewRecordModal"
        @added="conceptonAdded"
        @closeAddUser="addNewRecordModal = false"
        :dialogI="addNewRecordModal"
      />
      <SemenEmbryoFormEdit 
        v-if="updateRecordModal"
        @added="conceptonAdded"
        @closeAddUser="updateRecordModal = false"
        :dialogI="updateRecordModal"
        :editedItem="editedItem"
      />
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
import ConfirmBox from "@/components/ConfirmBox";
import loadingMixin from "@/mixins/LoadingMixin";
import SemenEmbryoForm from "./SemenEmbryoForm.vue";
import SemenEmbryoFormEdit from "./SemenEmbryoFormEdit.vue";

export default {
  components: {
      ConfirmBox,
      SemenEmbryoForm,
      SemenEmbryoFormEdit
  },
  created() {
    const fetchData = async () => {
      // this.getSingleAnimalData(this.$route.params.animal_number)
    };
    fetchData();
    if (this.checkBreakPoints) this.getTabletSingleAnimalData();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  async mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  watch: {
    options: {
      handler() {
        this.getSingleAnimalData();
      },
      deep: true,
    },
  },
  data() {
    return {
      editedItem: null,
      updateRecordModal: false,
      addNewRecordModal: false,
      totalConception: 0,
      search: "",
      from: 0,
      to: 0,
      totalPages: 1,
      options: {},
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      loading: true,
      confirm: false,
      confirmElements: {
        title: "Remove Conception",
        message: "Are you sure you want to remove this Animal semen/ambryo Information this will be permanently removed from the listing?",
        confirmBtnText: "Yes",
        cancelBtnText: "No",
        confirmData: {},
      },
      headers: [
        {
          text: this.$t('dashboardS.matingDate'),
          align: "start",
          sortable: false,
          value: "matingDate",
          width: '120px'
        },
        { text: this.$t('dashboardS.sireId'), value: "sire.animalNumber", width: '150px' },
        { text: this.$t('dashboardS.srgDamId'), value: "surrogateDam.animalNumber", width: '160px' },
        { text: this.$t('dashboardS.embOrgName'), value: "embryoOrgName", width: '190px' },
        { text: this.$t('dashboardS.srgDamBreed'), value: "surrogateDamBreed", width: '190px' },
        { text: this.$t('dashboardS.sireBreed'), value: "sireBreed", width: '150px' },
        { text: this.$t('action'), value: "action", sortable: false, width: '150px' },
      ],
      conceptionData: [],

      menu: false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      tableHeaders: [],
      oldSelected: [],
      allSelectedHeaders: [
        this.$t('dashboardS.matingDate'),
        this.$t('dashboardS.sireId'),
        this.$t('dashboardS.srgDamId'),
        this.$t('dashboardS.embOrgName'),
        this.$t('dashboardS.srgDamBreed'),
        this.$t('dashboardS.sireBreed'),
        this.$t('action')
      ],
      noRecordHeader: [
        this.$t('dashboardS.matingDate'),
        this.$t('dashboardS.sireId'),
        this.$t('dashboardS.srgDamId'),
        this.$t('dashboardS.embOrgName'),
        this.$t('dashboardS.srgDamBreed'),
        this.$t('dashboardS.sireBreed'),
        this.$t('action')
      ],
    };
  },
  methods: {
    editItem(item) {
      this.editedItem = item;
      this.updateRecordModal = true;
    },
    conceptonAdded() {
      this.options.page = 1;
      this.getSingleAnimalData()
      this.addNewRecordModal = false
      this.editedItem = null;
      this.updateRecordModal = false
    },
    deleteConfirm(item) {
      this.confirmElements.confirmData = item;
      this.confirm = true;
    },
    confirmDelete(action, confirmData) {
            if (action) {
              console.log(confirmData)
                this.startLoading();
                AnimalService.deleteAnimalConception(confirmData.id, 'semenemb')
                .then((res) => {
                  // console.log('conception delete', res.data.deleted)
                    this.stopLoading();
                    this.confirm = false;
                    this.getSingleAnimalData();
                    this.$notify({
                        title: "Semenn/Emb data deleted.",
                        text: res.message,
                        type: "success",
                    });
                })
            .catch((err) => {
                console.log(err);
                this.stopLoading();
                this.confirm = false;
            });
            } else {
                this.confirm = false;
            }
    },
    searchData() {
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletSingleAnimalData();
      } else {
        this.options.page = 1;
        this.getSingleAnimalData();
      }
    },
    getSingleAnimalData() {
      this.loading = true;
      AnimalService.getAnimalSectionDate(
        "conception",
        this.$route.params.animal_number,
        "semenembryo",
        this.options,
        this.search
      )
        .then((res) => {
          // if(res.data.animalConception.numRows > 0){
          this.conceptionData = res.data.animalConception.rows;
          this.totalConception = res.data.animalConception.totalRows;

          if (this.totalConception < 1) {
              this.oldSelected = this.selectedHeaders;
              this.selectedHeaders = this.noRecordHeader;														
            } else {
              if (this.oldSelected.length > 1)
                this.selectedHeaders = this.oldSelected;
              else {
                this.selectedHeaders = this.allSelectedHeaders;
                this.oldSelected = [];
              }
            }

            this.resetTableStructure();

          this.totalPages = Math.ceil(
            this.totalConception / this.options.itemsPerPage
          );
          this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
          this.to =
            this.options.page * this.options.itemsPerPage -
            (this.options.itemsPerPage - res.data.animalConception.numRows);
          this.loading = false;
          // }else{
          //     this.conceptionData = []
          //     this.loading = false;
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTabletSingleAnimalData() {
      this.loading = true;
      AnimalService.getAnimalSectionDate(
        "conception",
        this.$route.params.animal_number,
        "semenembryo",
        this.tabletTableOptions,
        this.search
      )
        .then((res) => {
          // if(res.data.animalConception.numRows > 0){
          this.conceptionData = res.data.animalConception.rows;
          this.totalConception = res.data.animalConception.totalRows;
          this.totalPages = Math.ceil(
            this.totalConception / this.tabletTableOptions.itemsPerPage
          );
          this.from =
            (this.tabletTableOptions.page - 1) *
              this.tabletTableOptions.itemsPerPage +
            1;
          this.to =
            this.tabletTableOptions.page *
              this.tabletTableOptions.itemsPerPage -
            (this.tabletTableOptions.itemsPerPage -
              res.data.animalConception.numRows);
          this.loading = false;
          // }else{
          //     this.conceptionData = []
          //     this.loading = false;
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      this.getSingleAnimalData();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getTabletSingleAnimalData();
    },
    resetSearchOnEmpty() {
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletSingleAnimalData();
      } else {
        this.options.page = 1;
        this.getSingleAnimalData();
      }
    },
    resetTableStructure() {
      // this.startLoading();
      this.loading = true;
      this.tableHeaders = this.headers.filter((header) =>                         //this.headrs - is original 
        this.selectedHeaders.includes(header.text)
      );
      this.options.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      // this.stopLoading();
      this.loading = false;
    },
  },
  mixins: [loadingMixin]
};
</script>
<style lang="scss" scoped>
</style>